import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout/paycools-index.vue'
import { developManageRouter } from './develop-manage/develop-manage'
import { financialRouter, financialAgentRouter } from './financial/financial'
import { transitionRouter, transitionAgentRouter } from './transaction/transition'
import { customerServiceRouter } from './customer-service/customer-service'
import { systemRouter } from './system/system'
import { agentMerchantRouter } from './agent-merchant/agent-merchant.js'
import { onlinePayoutShowRouter } from './online-transaction/online-transaction'
import { checkoutRouter } from './checkout/checkout'
import { onlinePaymentShowRouter } from '@/router/paycools/kyc/kyc'
import { paymentLinkRouter } from '@/router/paycools/payment-link/payment-link'
import { serviceProviderToolsRouter } from '@/router/paycools/service-provider-tools/service-provider-tools'
import { paymentToolsRouter } from '@/router/paycools/payment-tools/payment-tools'
import { operationManageRouter } from '@/router/paycools/operation-manage/operation-manage'
// import { paymentPageRouter } from './payment-page/payment-page'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/paycools/login/index'),
    hidden: true
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: () => import('@/views/paycools/login/forgot-password'),
    hidden: true
  },
  {
    path: '/payToken/authorization',
    name: 'payTokenAuthorization',
    component: () => import('@/views/paycools/directDebit/payToken-authorization'),
    hidden: true
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/paycools/register/index'),
    hidden: true
  },
  {
    path: '/register/services-agreements',
    name: 'Services_Agreements',
    component: () => import('@/views/paycools/register/services-agreements'),
    hidden: true
  },
  {
    path: '/register/privacy-policy',
    name: 'Privacy_Policy',
    component: () => import('@/views/paycools/register/privacy-policy'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/paycools/layout/404'),
    hidden: true
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: () => import('@/views/paycools/questionnaire/questionnaire'),
    meta: {
      title: 'questionnaire', noCache: false
    },
    hidden: true
  },
  // {
  //   path: '/payment/pay/:no',
  //   name: 'Payment_Page_Pay',
  //   component: () => import('@/views/paycools/paymentPage/paymentPagePayLink'),
  //   meta: {
  //     title: 'payment_page_pay', noCache: false
  //   },
  //   hidden: true
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/paycools/dashboard/index.vue'),
        meta: { title: 'dashboard', icon: 'home-filling' }
      },
      {
        path: 'systemManage/settings',
        name: 'System_User_Setting',
        component: () => import('@/views/paycools/system/system-account-settings'),
        meta: {
          title: 'account_settings', noCache: false
        },
        hidden: true
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/paycools/no-need-authorities/notifications.vue'),
        meta: {
          title: 'notifications', noCache: false
        },
        hidden: true
      },
      {
        path: 'notifications/detail/:user_detail_no',
        name: 'Notification_Detail',
        component: () => import('@/views/paycools/no-need-authorities/notifications-detail.vue'),
        meta: {
          title: 'notifications', noCache: false
        },
        hidden: true
      }
    ]
  }

]

const createRouter = () => new Router({
  // mode: 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export const asyncRoutes = [
  serviceProviderToolsRouter,
  agentMerchantRouter,
  financialAgentRouter,
  financialRouter,
  transitionRouter,
  transitionAgentRouter,
  customerServiceRouter,
  checkoutRouter,
  paymentLinkRouter,
  onlinePayoutShowRouter,
  paymentToolsRouter,
  operationManageRouter,
  developManageRouter,
  systemRouter,
  onlinePaymentShowRouter,
  { path: '*', redirect: '/404', hidden: true }
]

export default router
